export enum EButtonColor {
	BLUE = 'blue',
	PURPLE = 'purple',
	ORANGE = 'orange',
	GREEN = 'green',
	GRAY = 'gray',
	PINK = 'pink',
}
